import { get, isNil } from 'lodash-es';
import { isJson } from '../../utils/utils';

/**
 * Extracts tag IDs from a record field, handling both string arrays and object arrays.
 * This is used for both custom properties (which store stringified arrays) and regular tag fields.
 *
 * @param record - The record containing the tag data
 * @param field - The field path to extract tags from (default: 'tags')
 * @returns Array of tag IDs as strings
 */
export function extractTagIds<T extends Record<string, unknown>>(
	record: T,
	field: string = 'tags'
): string[] {
	// Handle the case where the field value is a stringified array, which is the
	// case for custom properties.
	const fieldValue = get(record, field);
	const parsedValue = isJson(fieldValue as string)
		? JSON.parse(fieldValue as string)
		: fieldValue;
	const tagsList = Array.isArray(parsedValue) ? parsedValue : [parsedValue];
	return (tagsList ?? [])
		.map((tag) => (typeof tag === 'object' ? tag?.id : tag))
		.filter((tag: string | undefined | null) => !isNil(tag)) as string[];
}
